import { Component, createEffect, createSignal, mergeProps } from 'solid-js';
import {
  POINT_CLOUD_INTENSITY_DEFAULTS,
  PointCloudIntensityControlProps,
} from './point-cloud-intensity.model';
import {
  applyColorInputStyle,
  fixModusSliderStyle,
} from '../../utils/style-fixes';
import { t } from '@trimble/i18n';

export const PointCloudIntensityControl: Component<
  PointCloudIntensityControlProps
> = (props: PointCloudIntensityControlProps) => {
  applyColorInputStyle();
  fixModusSliderStyle();

  const activeProps = mergeProps(POINT_CLOUD_INTENSITY_DEFAULTS, props);

  const [startColor, setStartColor] = createSignal<string>('');
  const [endColor, setEndColor] = createSignal<string>('');
  const [offset, setOffset] = createSignal<number>(0);

  createEffect(() => {
    setStartColor(activeProps.startColor);
  });

  createEffect(() => {
    setEndColor(activeProps.endColor);
  });

  createEffect(() => {
    setOffset(activeProps.offset);
  });

  const handleOffsetChange = (value: number): void => {
    setOffset(value);
    handleGradientChange();
  };

  const handleStartColorChange = (color: string): void => {
    setStartColor(color);
    handleGradientChange();
  };

  const handleEndColorChange = (color: string): void => {
    setEndColor(color);
    handleGradientChange();
  };

  function handleGradientChange(): void {
    props.onGradientChange?.({
      startColor: startColor(),
      endColor: endColor(),
      offset: offset(),
    });
  }

  return (
    <div class="w-full flex-col flex">
      <div class="flex flex-1 flex-col gap-1">
        <span class="flex flex-1" id="intensity-gradient-label">
          {t('mobileMapping.styles.intensity.intensityGradient')}
        </span>
        <div class="flex flex-row items-center gap-2">
          <input
            id="startColor"
            name="startColor"
            type="color"
            value={startColor()}
            onInput={(e) => {
              const color = (e.target as HTMLInputElement).value;
              handleStartColorChange(color);
            }}
          />
          <modus-wc-slider
            aria-labelledby="intensity-gradient-label"
            class="flex-1 h-5"
            attr:value={offset()}
            attr:min={0}
            attr:max={1}
            attr:step={0.1}
            on:inputChange={(e) => {
              const offset = parseFloat(
                (e.detail.target as HTMLInputElement).value
              );
              handleOffsetChange(offset);
            }}
          />
          <input
            id="endColor"
            name="endColor"
            type="color"
            value={endColor()}
            onInput={(e) => {
              const color = (e.target as HTMLInputElement).value;
              handleEndColorChange(color);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PointCloudIntensityControl;
